export default "__VITE_ASSET__0ba215af__"